import { Pipe, PipeTransform } from '@angular/core';
import { convertEnumToOptions } from '../../common/decorators/description.decorator';

/**
 * 轉換 Enum class 對應的文字顯示
 *
 * @export
 * @param {*} value
 * @param {*} enumType
 * @return {*}  {*}
 */
export function formatEnumOptions(value: any, enumType: any): any {
  const options = convertEnumToOptions(enumType);
  const option = options.find((x) => x.value === value);
  return option?.label ?? value;
}

/**
 * Enum class 轉換文字顯示 pipe
 *
 * @export
 * @class EnumOptionsMappingPipe
 * @implements {PipeTransform}
 */
@Pipe({
  name: 'enumOptionsMapping',
})
export class EnumOptionsMappingPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    return formatEnumOptions(value, args[0]);
  }
}
